export default "__VITE_ASSET__C11zsNO7__"